<template>
  <div>
    <!-- <h1>Cloud Projects</h1> -->
    <pre>"{{ this.projectDetail2 }}":[</pre>
    <div v-for="project in projects" :key="project.id">
      <pre>{{ project.url }}</pre>
    </div>
    <pre>],</pre>
  </div>
</template>

<script>
export default {
  name: 'myCloudyi',
  props: {
    projectPath: {
      type: String,
      required: true,
    },
    projectDetail: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      projects: [], // Array to store project data
    };
  },
  created() {
    this.fetchProjects();
  },
  computed:
  {
    projectDetail2()
    {

    return this.projectDetail.replace(/\//g, '_');
    }
  },
  methods: {

    async fetchProjects() {
  try {
    const response = await fetch("http://localhost:3000/api/images?folder=" + this.projectPath + "/" + this.projectDetail);
    const data = await response.json();

    // Transform the array of strings into an array of objects
    const lastIndex = data.length - 1;
    this.projects = data.map((url, index) => {
      // Extract the part of the URL after the second "/"
      const parts = url.split('/');
      const modifiedUrl = parts.slice(2).join('/');
      return {
        url: index !== lastIndex ? '"' + modifiedUrl + '",' : '"' + modifiedUrl + '"'
      };
    });
  } catch (error) {
    console.error("Error fetching projects:", error);
  }
},
  },
};
</script>

<style scoped>
/* Add your component styles here */
ul {
  list-style-type: none;
  padding: 0;
}

li {
  border: 1px solid #ddd;
  margin: 10px 0;
  padding: 10px;
}

img {
  max-width: 100%;
  height: auto;
}
</style>
